// import React from 'react'
// import Hero from '../components/Hero'
// import ClientSlider from '../components/ClientSlider'
// import Stats from '../components/Stats'
// import Why from '../components/Why'
// import ClientSays from '../components/ClientSays'
// import Deliveries from '../components/Deliveries'
// import Unlock from '../components/unlockThePower'
// import StayContact from '../components/StayContact'
// import Stats2 from '../components/Stats2'
// import Why2 from '../components/Why2'
// import KeyFeature from '../components/KeyFeature'
// import Deliveries2 from '../components/Delivery2'

// function Home() {
//     return (
//         <div className=''>
//             <Hero />
//             <ClientSlider />
//             <Stats2 />
//             <Why2 />
//             <KeyFeature />
//             <Deliveries2 />
//             <Unlock />
//             {/* <StayContact /> */}
//         </div>
//     )
// }

// export default Home

import React from 'react'
import Hero from '../components/home/Hero'
import ProblemSection from '../components/home/ProblemSection'
import Provision29Section from '../components/home/Provision29Section'
import SolutionSection from '../components/home/SolutionSection'
import HowItWorksSection from '../components/home/HowItWorksSection'
import ValueSection from '../components/home/ValueSection'
import EntryOfferSection from '../components/home/EntryOfferSection'
import WhoThisIsForSection from '../components/home/WhoThisIsForSection'
import FinalCTASection from '../components/home/FinalCTASection'

function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <ProblemSection />
      <Provision29Section />
      <SolutionSection />
      <HowItWorksSection />
      <ValueSection />
      <EntryOfferSection />
      <WhoThisIsForSection />
      <FinalCTASection />
    </div>
  )
}
export default Home

